import { PendoAnalytics } from '../../directives/analytics/pendo-analytics.js';
import PendoIcon from '../icon/pendo-icon.vue.js';

var script = {
  name: 'PendoAlert',
  components: {
    PendoIcon
  },
  directives: {
    PendoAnalytics
  },
  props: {
    type: {
      default: 'info',
      type: String,
      validator: value => ['error', 'info', 'success', 'warning'].includes(value)
    },
    title: {
      default: '',
      type: String
    },
    description: {
      default: '',
      type: String
    },
    center: {
      default: false,
      type: Boolean
    },
    showIcon: {
      default: true,
      type: Boolean
    },
    closable: {
      default: false,
      type: Boolean
    },
    inline: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      visible: true
    };
  },
  computed: {
    icon() {
      return {
        success: 'check-circle-2-solid',
        info: 'info-solid',
        warning: 'alert-circle-solid',
        error: 'minus-circle-solid'
      }[this.type];
    },
    hasTitle() {
      return this.title || this.$slots.title;
    },
    hasDescription() {
      return this.description || this.$slots.default;
    }
  },
  methods: {
    close() {
      this.visible = false;
      this.$emit('close');
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-alert.vue2.js.map
